import { render } from "./HeaderFranchise.vue?vue&type=template&id=e9ffdbde&scoped=true&lang=pug"
import script from "./HeaderFranchise.vue?vue&type=script&lang=js"
export * from "./HeaderFranchise.vue?vue&type=script&lang=js"

import "./HeaderFranchise.vue?vue&type=style&index=0&id=e9ffdbde&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9ffdbde"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QToolbar,QBtn,QIcon});
